import { ReactNode } from 'react';

export const Background = ({
  children,
  fullScreen = false,
}: {
  children?: ReactNode;
  fullScreen?: boolean;
}) => (
  <div
    className={`items-center justify-center ${
      fullScreen
        ? 'flex h-fit min-h-screen w-screen bg-gradient-to-br from-primary/80 to-secondary/80'
        : 'hidden h-screen w-2/5 md:flex bg-gradient-to-br from-primary/80 to-secondary/80'
    }`}
  >
    {children}
  </div>
);
